import Handlebars from 'handlebars';
import _ from 'underscore';
import { Log } from '@biteinc/common';
export function validateTemplate(templateStr) {
    try {
        Handlebars.precompile(templateStr); // Check that it compiles
        return true;
    }
    catch (error) {
        Log.error('err compiling template', error);
        return false;
    }
}
export function getUnusedTokenNames(templateStrings, tokenNames) {
    const templateStr = templateStrings.join(' ');
    return _.uniq(tokenNames).filter((tokenName) => {
        return templateStr.indexOf(`{{${tokenName}}}`) < 0;
    });
}
export function getUnusableTokenNames(templateStrings, tokenNames) {
    const unusableTokens = [];
    const regExp = /{{(.*?)}}/g;
    const templateStr = templateStrings.join(' ');
    const usedTokens = [...(templateStr.match(regExp) || [])].map((matchedToken) => {
        return matchedToken.replace('{{', '').replace('}}', '');
    });
    usedTokens.forEach((usedToken) => {
        if (!tokenNames.includes(usedToken)) {
            unusableTokens.push(usedToken);
        }
    });
    return unusableTokens;
}
/** @description Escapes the text  */
export function renderHtmlTemplate(templateStr, data) {
    return Handlebars.compile(templateStr)(data);
}
/** @description Escapes the text  */
export function renderUnescapedTemplate(templateStr, data) {
    return Handlebars.compile(templateStr, { noEscape: true })(data);
}
//# sourceMappingURL=handlebars_helper.js.map